<script setup lang="ts">
interface Props {
  variant?: 'error' | 'warning' | 'info' | 'success'
}

withDefaults(defineProps<Props>(), {
  variant: 'info'
})
</script>

<template>
  <div :class="['alert', `alert--${variant}`]" role="alert">
    <slot />
  </div>
</template>

<style scoped>
/* Variant classes like .alert--error are dynamically applied via :class binding */
.alert {
  padding: var(--spacing-md);
  border-radius: var(--radius-base);
  font-size: var(--font-size-sm);
  line-height: var(--line-height-normal);
  border: 1px solid;
}

.alert--error {
  background-color: var(--color-semantic-error-background);
  color: var(--color-semantic-error);
  border-color: var(--color-semantic-error-focus-ring);
}

.alert--warning {
  background-color: var(--color-semantic-warning-background);
  color: var(--color-semantic-warning);
  border-color: var(--color-semantic-warning);
}

.alert--info {
  background-color: var(--color-semantic-info-background);
  color: var(--color-semantic-info);
  border-color: var(--color-semantic-info);
}

.alert--success {
  background-color: var(--color-semantic-success-background);
  color: var(--color-semantic-success-dark);
  border-color: var(--color-semantic-success-dark);
}
</style>
